import React from "react";
import Select from "react-select";
import Navbar from "../../../Components/Navbar";
import Siderbar from "../../../Components/Sidebar";
import DeletePopUP from "../../../Components/CommonPopUp/DeletePopUp";
import FabAdd from "../../../Components/FabAdd/FabAdd";
import Toast from '../../../Components/Toast/Toast'
import AddAssignPopUp from "./PopUp/AddAssignPopUp";
import ApiLoader from "../../../Components/Loader/ApiLoader";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import AddAssignUpdatePopUp from "./PopUp/AddAssignUpdatePopUp";

export default function DistrictTalukaWiseMapping() {
  
  const UserID = sessionStorage.getItem("userID")
  const [deletePopUpShow, setdeletePopUpShow] = React.useState(false);
  const [deleteRecord, setdeleteRecord] = React.useState(false);
  const [isopen, setIsOpen] = React.useState(false);
  const [popupflag, setpopupflag] = React.useState("");
  const [loading, setloading] = React.useState(false)
  const [TableUserGrid, setTableUserGrid] = React.useState([])
  const [PerPage, setPerPage] = React.useState(10)
  const [Loaded, setLoaded] = React.useState(false)
  const [NoRecords, setNoRecords] = React.useState(false)
  const [isPost, setisPost] = React.useState(false)



  const [SurveyorDDL, setSurveyorDDL] = React.useState([])
  const [SurveyorID, setSurveyorID] = React.useState(0)
  const [SurveyorName, setSurveyorName] = React.useState('')

  const [DistrictDDL, setDistrictDDL] = React.useState([])
  const [DistrictID, setDistrictID] = React.useState(0)
  const [DistrictName, setDistrictName] = React.useState('')

  const [TalukaDDL, setTalukaDDL] = React.useState([])
  const [TalukaID, setTalukaID] = React.useState(0)
  const [TalukaName, setTalukaName] = React.useState('')


  

  const toggle = () => {
    setIsOpen(!isopen);
  };

  const [showDeletePopup, setshowDeletePopup] = React.useState(false)
  const [deletePopUpData, setdeletePopUpData] = React.useState([])

  const handdleShowDeletePopup = (data, show) => {
    setshowDeletePopup(show)
    setdeletePopUpData(data)
  }



  const [showAddPopUp, setshowAddPopUp] = React.useState(false)
  const [PopUpData, setPopUpData] = React.useState('')

  const handelAddPopUpClick = (data, show) => {
    setshowAddPopUp(show)
    setPopUpData(data)
  }
  const [showUpdatePopUp, setshowUpdatePopUp] = React.useState(false)
  const [UpdatePopUpData, setUpdatePopUpData] = React.useState('')

  const handelUpdatePopUpClick = (data, show) => {
    setshowUpdatePopUp(show)
    setUpdatePopUpData(data)
  }


  

  const Clear = () => {
    setDistrictID('')
    setDistrictName('')
    setTalukaID('')
    setTalukaName('')
    setSurveyorID('')
    setSurveyorName('')
  }

  const Delete = (deletePopUpData) => {
 
  }

  const handleContainerOnBottom = () => {

    if (TableUserGrid) {
      if (PerPage <= TableUserGrid.length) {
        setTimeout(() => {
          setPerPage(PerPage + 10)
          setloading(true)
        }, 300);
      } else {
        setNoRecords(true)
        setloading(false)
      }
    }

  };
  const containerRef = useBottomScrollListener(handleContainerOnBottom);


  return (
    <>
      <div className="mt-2">
        <div className="container-scroller">
          <Navbar toggle={toggle} isopen={isopen} />
          <div className="container-fluid page-body-wrapper">
            <Siderbar isopen={isopen} toggle={toggle} active="district_taluka_wise_surveyor_mapping" />
            {
              loading ?
                <ApiLoader />
                : ''
            }
            <div className="main-panel" style={{ width: isopen ? "calc(100%  - 120px )" : "", marginLeft: isopen ? "130px" : "" }}>

              <main className="main-content position-relative border-radius-lg ">
                <div className="content-wrapper ">
                  <div className="row">
                    <div className="col-md-12 col-sm-12">
                      <div className="row page-heading col-12 col-lg-12 col-md-12 mb-xl-0  px-5 float-left">
                        <h4 className="font-weight-semi-bold text-white ">
                          District/ Taluka wise Surveyor Mapping
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 ">
                    <div className="card mb-4 overflow-hidden">
                      <div className="card-body px-4 py-2 linear-g">
                        <div className="row mb-4 px-2">
                          <div className=" col-lg-3">
                            <div className="form-group m-0">
                              <label>Surveyor Name</label>
                              <Select
                                isClearable
                                autoFocus
                                id="branch"
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                theme={theme => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    neutral50: '#363738',  // Placeholder color
                                  },
                                })}
                                value={SurveyorName}
                                placeholder={SurveyorName === "" ? "Select..." : SurveyorName}
                                // placeholder={VillageName === "" && popupdata.villageName !== null ? popupdata.villageName : VillageName}
                                options={
                                  SurveyorDDL ? SurveyorDDL.map(item => ({
                                    ID: item.m_TableUserMasterID,
                                    label: item.employeeName

                                  })) : 'Loading'
                                }
                                onChange={(e) => {
                                  console.log(e)
                                  setSurveyorID(e !== null ? e.ID : '');
                                  setSurveyorName(e !== null ? e.label : '');

                                }}
                              />
                            </div>
                          </div>
                          <div className=" col-lg-3">
                            <div className="form-group m-0">
                              <label>District</label>
                              <Select
                                isClearable
                                autoFocus
                                id="branch"
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                theme={theme => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    neutral50: '#363738',  // Placeholder color
                                  },
                                })}
                                value={DistrictName}
                                placeholder={DistrictName === "" ? "Select..." : DistrictName}
                                // placeholder={VillageName === "" && popupdata.villageName !== null ? popupdata.villageName : VillageName}
                                options={
                                  DistrictDDL ? DistrictDDL.map(item => ({
                                    ID: item.id,
                                    label: item.districtName

                                  })) : 'Loading'
                                }
                                onChange={(e) => {
                                  console.log(e)
                                  setDistrictID(e !== null ? e.ID : '');
                                  setDistrictName(e !== null ? e.label : '');

                                }}
                              />
                            </div>
                          </div>
                          <div className=" col-lg-3">
                            <div className="form-group m-0">
                              <label> Taluka</label>
                              <Select
                                isClearable
                                autoFocus
                                id="branch"
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                theme={theme => ({
                                  ...theme,
                                  colors: {
                                    ...theme.colors,
                                    neutral50: '#363738',  // Placeholder color
                                  },
                                })}
                                value={TalukaName}
                                placeholder={TalukaName === "" ? "Select..." : TalukaName}
                                // placeholder={VillageName === "" && popupdata.villageName !== null ? popupdata.villageName : VillageName}
                                options={
                                  TalukaDDL ? TalukaDDL.map(item => ({
                                    ID: item.id,
                                    label: item.talukaName

                                  })) : 'Loading'
                                }
                                onChange={(e) => {
                                  console.log(e)
                                  setTalukaID(e !== null ? e.ID : '');
                                  setTalukaName(e !== null ? e.label : '');

                                }}
                              />
                            </div>
                          </div>

                          <div className="col-xl-1 col-lg-1  ">
                            <div className="form-group   m-0 d-flex justify-content-center align-items-end h-100">
                              <button
                                type="button"
                                onClick={Clear}
                                className="btn clear-btn mb-0"
                              >
                                Clear
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* <TableData /> */}

                        <div className="table-responsive p-0" ref={containerRef} style={{ height: "55vh" }} >
                          <table className="table table-bordered">
                            <thead>
                              <tr className="bg-gradient-dark text-white">
                                <th className=" w-6 v_sr_width">Sr. No.</th>
                                <th className=" ps-2">Surveyor Name</th>
                                <th className=" ps-2">District</th>
                                <th className=" ps-2">Taluka</th>

                                <th className=" ps-2  w-10 v_sr_width">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {

                                TableUserGrid && TableUserGrid !== 0 ? TableUserGrid.map((i, j) => {
                                  return (
                                    <>
                                      <tr>
                                        <td align="center">{j + 1}</td>
                                        <td>{i.surveyorName ? i.surveyorName : '-'}</td>
                                        <td>{i.districtName ? i.districtName : '-'}</td>
                                        <td>{i.talukaName ? i.talukaName : '-'}</td>

                                        <td align="center">
                                          <i className="fa fa-edit mx-2 v_icon_style" title="Edit"
                                            onClick={() => handelUpdatePopUpClick({
                                              Flag: "dada",
                                              popUpData: i
                                            }, true)}
                                          ></i>
                                          <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                            onClick={() => {
                                              handdleShowDeletePopup({
                                                flag: 'dada',
                                                data: i
                                              }, true)
                                            }
                                            }
                                            title="Do you want to delete this record?"></i>
                                        </td>
                                      </tr>

                                    </>
                                  )
                                })
                                  :
                                  <tr>
                                    <td colSpan={12} className="text-center">
                                      <img className="ml-5 text-center" src="./assets/img/Datanotfound.png" style={{ width: "61px", alignItems: "center", marginLeft: "-200px" }} />
                                      <h6 className="ml-5 bold" >
                                        Record Not Found
                                      </h6>

                                    </td>
                                  </tr>

                              }

                            </tbody>
                          </table>
                          <div style={{ marginBottom: '1%', marginTop: "1%" }}>
                            {
                              !NoRecords && !Loaded && TableUserGrid && TableUserGrid.length > 0 ?

                                <div className="text-center">
                                  <button className='btn btn-outline-primary' style={{ borderRadius: '8px' }}
                                    onClick={handleContainerOnBottom}
                                  >Load More
                                  </button>
                                </div> : ''
                            }
                            <div className="text-center">
                              {
                                loading ?
                                  <ApiLoader />
                                  : ''
                              }
                              {/* <ApiLoader color='#ff7d00' loading={Loaded} size={150} /> */}
                            </div>


                            {
                              NoRecords ?
                                <div className="text-center">
                                  <text style={{ textAlign: 'center' }}>No More Records ...</text>
                                </div>
                                : ''
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>

      <div id="fab"
        onClick={() => {
          handelAddPopUpClick({
            flag: "dada"
          }, true)
        }}
      >
        <span>ADD</span>
        <i className="fas fa-plus" style={{ fontSize: "20px", color: "#fff" }}></i>
      </div>

      {
        showAddPopUp ?
          <AddAssignPopUp
            setshowAddPopUp={setshowAddPopUp}
            PopUpData={PopUpData}
            setisPost={setisPost}
            isPost={isPost}
            setloading={setloading}
            Toast={Toast}
          /> : <></>
      }

      {
        showDeletePopup ?
          <DeletePopUP
            heading="District/ Taluka wise Surveyor Mapping"
            message={"Do You Want To Delete This Record ?"}
            setshowDeletePopup={setshowDeletePopup}
            deletePopUpData={deletePopUpData}
            Delete={Delete}
          /> : <></>
      }
      {
        showUpdatePopUp ?
          <AddAssignUpdatePopUp
            setshowUpdatePopUp={setshowUpdatePopUp}
            UpdatePopUpData={UpdatePopUpData}
            isPost={isPost}
            setloading={setloading}
            Toast={Toast}
          />
          : ''
      }
    </>
  );
}
